"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
const localizeUtils_1 = require("../../../common/localizeUtils");
exports.Messages = {
    needInstallNpm: () => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.needInstallNpm"),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.needInstallNpm"),
    }),
    failToValidateFuncCoreTool: (functionVersionErrMsg) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.failToValidateFuncCoreTool", functionVersionErrMsg),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.failToValidateFuncCoreTool", functionVersionErrMsg),
    }),
    portableFuncNodeNotMatched: (nodeVersion, funcVersion) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.portableFuncNodeNotMatched")
            .replace("@NodeVersion", nodeVersion)
            .replace("@FuncVersion", funcVersion),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.portableFuncNodeNotMatched")
            .replace("@NodeVersion", nodeVersion)
            .replace("@FuncVersion", funcVersion),
    }),
    symlinkDirAlreadyExist: (linkFilePath) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.symlinkDirAlreadyExist", linkFilePath),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.symlinkDirAlreadyExist", linkFilePath),
    }),
    invalidFuncVersion: (version) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.invalidFuncVersion", version),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.invalidFuncVersion", version),
    }),
    noSentinelFile: () => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.noSentinelFile"),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.noSentinelFile"),
    }),
    funcVersionNotMatch: (funcVersion, expectedFuncVersion) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.funcVersionNotMatch", funcVersion, expectedFuncVersion),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.funcVersionNotMatch", funcVersion, expectedFuncVersion),
    }),
    downloadDotnet: () => (0, localizeUtils_1.getLocalizedString)("depChecker.downloadDotnet"),
    finishInstallDotnet: () => (0, localizeUtils_1.getLocalizedString)("depChecker.finishInstallDotnet"),
    useGlobalDotnet: () => (0, localizeUtils_1.getLocalizedString)("depChecker.useGlobalDotnet"),
    dotnetInstallStderr: () => (0, localizeUtils_1.getLocalizedString)("depChecker.dotnetInstallStderr"),
    dotnetInstallErrorCode: () => (0, localizeUtils_1.getLocalizedString)("depChecker.dotnetInstallErrorCode"),
    dotnetNotFound: () => (0, localizeUtils_1.getLocalizedString)("depChecker.dotnetNotFound"),
    // depsNotFound: () => getLocalizedString("depChecker.depsNotFound"),
    testToolVersionNotMatch: (version, expectedVersion) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.testToolVersionNotMatch", version, expectedVersion),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.testToolVersionNotMatch", version, expectedVersion),
    }),
    failToValidateTestTool: (errorMessage) => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.failedToValidateTestTool", errorMessage),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.failedToValidateTestTool", errorMessage),
    }),
    failToValidateVxTestAppInstallOptions: () => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.failToValidateVxTestAppInstallOptions"),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.failToValidateVxTestAppInstallOptions"),
    }),
    failToValidateVxTestApp: () => ({
        default: (0, localizeUtils_1.getDefaultString)("depChecker.failToValidateVxTestApp"),
        localized: (0, localizeUtils_1.getLocalizedString)("depChecker.failToValidateVxTestApp"),
    }),
    failToDownloadFromUrl: () => (0, localizeUtils_1.getLocalizedString)("depChecker.failToDownloadFromUrl"),
    linuxDepsNotFound: () => (0, localizeUtils_1.getLocalizedString)("depChecker.linuxDepsNotFound"),
};
//# sourceMappingURL=message.js.map